export default __webpack_public_path__ + "static/media/test3.906e7124.png";